import { render, staticRenderFns } from "./PageMathGame.vue?vue&type=template&id=a30b42d2&"
import script from "./PageMathGame.vue?vue&type=script&lang=js&"
export * from "./PageMathGame.vue?vue&type=script&lang=js&"
import style0 from "./PageMathGame.vue?vue&type=style&index=0&id=a30b42d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports